/* eslint-disable */
import { produce } from "immer";
import {
  TRA_CHANGE_WITH_FUNDSWITCH_FETCH_START,
  TRA_CHANGE_WITH_FUNDSWITCH_FETCH_SUCCESS,
  TRA_CHANGE_WITH_FUNDSWITCH_FETCH_FAILURE,
} from "../actions/types";

const traChangeWithFundSwitchReducer = (
  state = {
    traFundSwitchFetching: false,
    traFundSwitchData: [],
    traFundSwitchError: null,
  },
  action,
) => {
  switch (action.type) {
    case TRA_CHANGE_WITH_FUNDSWITCH_FETCH_START:
      return produce(state, (draft) => {
        draft.traFundSwitchFetching = true;
      });
    case TRA_CHANGE_WITH_FUNDSWITCH_FETCH_SUCCESS:
      return produce(state, (draft) => {
        draft.traFundSwitchFetching = true;
        draft.traFundSwitchData = action.data;
        draft.traFundSwitchFetching = false;
      });
    case TRA_CHANGE_WITH_FUNDSWITCH_FETCH_FAILURE:
      return produce(state, (draft) => {
        draft.traFundSwitchFetching = false;
        draft.traFundSwitchError = action.error;
      });
    default:
      return state;
  }
};

export default traChangeWithFundSwitchReducer;
